import React, {useContext} from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {authRoutes, noAuthRoutes} from '../routes';
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import SideBar from "./SideBar";

const AppRouter = () => {
    const pagesWithoutHeader = ["doc", "updates"];
    const {userStore} = useContext(Context);
    return (
        <>
            {userStore.isAuth && !pagesWithoutHeader.some(p => window.location.href.includes(p)) && <SideBar />}
            <Routes>
                {userStore.isAuth && authRoutes.map(({path, Component}) =>
                    <Route key={path} path={path} element={<Component/>} exact />
                )}
                {!userStore.isAuth && noAuthRoutes.map(({path, Component}) =>
                    <Route key={path} path={path} element={<Component/>} exact />
                )}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </>
    );
};

export default observer(AppRouter);